export const isValidSsn = (value) => {
    const isInvalidLength = value.length != 9;
    if (isInvalidLength) return false;

    const isOnlyNumbers = /^[0-9]*$/.test(value);
    if (!isOnlyNumbers) return false;

    const invalidStartValues = [ '000', '666' ];
    if(invalidStartValues.includes(value.substring(0, 3))) return false;

    const invalidMiddleValues = [ '00' ];
    if(invalidMiddleValues.includes(value.substring(3, 5))) return false;

    const invalidFinishValues = [ '0000' ];
    if(invalidFinishValues.includes(value.substring(5, 9))) return false;

    const blackList = [
        '000000000',
        '111111111',
        '222222222',
        '333333333',
        '444444444',
        '555555555',
        '666666666',
        '777777777',
        '888888888',
        '999999999',
        '123456789',
        '987654321',
        '012345678',
        '876543210'
    ];

    if (blackList.includes(value)) return false;

    return true
}